import { render, staticRenderFns } from "./ColumnBetaLinksReferral.vue?vue&type=template&id=74859372&"
import script from "./ColumnBetaLinksReferral.vue?vue&type=script&lang=ts&"
export * from "./ColumnBetaLinksReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports